import moment from "moment"

interface IAuctionType {
  label: string;
  type: string;
  status: string;
  buttonText: string
}

export const checkAuctionType = (startDate: string, endDate: string, currentBid?: number): IAuctionType => {
  if (moment(new Date()).isBefore(startDate)) {
    return {
      label: 'STARTING BID',
      type: 'pre_sale',
      status: `Starts ${moment(startDate).format('MMMM DD, hh:mm A')}`,
      buttonText: 'View Details'
    }
  } else if (moment(new Date()).isBetween(startDate, endDate)) {
    return {
      label: currentBid ? 'HIGHEST BID' : 'STARTING BID',
      type: 'during_sale',
      status: 'Auction in progress',
      buttonText: 'Bid Now'
    }
  } else {
    return {
      label: 'WINNING BID',
      type: 'post_sale',
      status: 'Auction complete',
      buttonText: 'View Details'
    }
  }
}